const shortMonth = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des']

const DATE_FILTER_TYPE = {
  TODAY: 'TODAY',
  LAST_THREE_DAYS: 'LAST_THREE_DAYS',
  LAST_WEEK: 'LAST_WEEK',
  LAST_MONTH: 'LAST_MONTH',
  LAST_THREE_MONTH: 'LAST_THREE_MONTH',
  CUSTOM_DATE: 'CUSTOM_DATE'
}

const DATE_FILTER_RANGE = {
  TODAY: 1,
  LAST_THREE_DAYS: 3,
  LAST_WEEK: 7,
  LAST_MONTH: 30,
  LAST_THREE_MONTH: 90
}

const DAY_IN_MILLIS = 24 * 60 * 60 * 1000
const SECOND_IN_MILLIS = 1000
const MINUTE_IN_MILLIS = 60 * 1000

const currentTimeMillis = () => {
  // return 1755161577000
  return Date.now()
}

const substractDay = (numOfDay, date = new Date()) => {
  date.setDate(date.getDate() - numOfDay)
  return date.getTime()
}

const addDay = (numOfDay, date = new Date()) => {
  date.setDate(date.getDate() + numOfDay)
  return date.getTime()
}

const getTodayDate = () => {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  return today
}

const setToStartDay = (millis) => {
  const date = new Date(millis)
  date.setHours(0, 0, 0, 0)
  return date.getTime()
}

const setToEndDay = (millis) => {
  const date = new Date(millis)
  date.setHours(23, 59, 59, 999)
  return date.getTime()
}

const simpleDateFormat = (millis) => {
  const date = new Date(millis)
  return `${date.getDate()} ${shortMonth[date.getMonth()]} ${date.getFullYear()}`
}

const formatDate = (value, format) => {
  if (value) {
    return new Date(value).format(format)
  }
  return ''
}

// 2025/12/15
const formatDateYYYYMMDD = (millis) => {
  const date = new Date(millis)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}/${month}/${day}`
}

const getLastNDays = (n) => {
  const now = new Date().valueOf()
  return {
    startDate: setToStartDay(now - (n - 1) * DAY_IN_MILLIS),
    endDate: setToEndDay(now)
  }
}

const getStartDateAndEndDateForDateFilterRange = (range, customStartDate, customEndDate) => {
  const endDate = setToEndDay(currentTimeMillis())
  if (range === DATE_FILTER_TYPE.CUSTOM_DATE) {
    return {
      startDate: customStartDate,
      endDate: customEndDate
    }
  } else {
    return {
      startDate: getLastNDays(DATE_FILTER_RANGE[range]).startDate,
      endDate
    }
  }
}

// 1 Mar 2005
const formatDateFromEpoch = (vm, value) => {
  if (!value) return ''

  const date = new Date(value)

  return date.toLocaleDateString(vm.$i18n.locale, {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  })
}

// 01 Mar 2005
const formatDateDDMonthYear = (value) => {
  if (!value) return ''
  return value.toLocaleDateString('id-ID', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  })
}

export {
  addDay,
  currentTimeMillis,
  formatDate,
  formatDateDDMonthYear,
  formatDateFromEpoch,
  formatDateYYYYMMDD,
  getLastNDays,
  getStartDateAndEndDateForDateFilterRange,
  getTodayDate,
  MINUTE_IN_MILLIS,
  SECOND_IN_MILLIS,
  setToEndDay,
  setToStartDay,
  simpleDateFormat,
  substractDay
}
